import React, {Component} from 'react';
import TextField from "@material-ui/core/TextField";
import './ProfileClubFilters.css';
import '../../Event/ProfileEventFilters/ProfileEventFilters.css';
import {FILTERING_OPTIONS, ALT_ICON, GENRE_CLUB, TYPE_CLUB} from '../../../../config/TextContent';
import { listToTreeUniqueValues, filterChildrenGenres, hasChildrenGenres, filterBasicGenres } from '../../../../client/Helper';
import TreeSelect from 'rc-tree-select';

class ProfileClubFilters extends Component {
    constructor(props, context){
        super(props, context);
        
        this.state = {
            tsGenresOpen: false,
            tsTypesOpen: false,
            tsChildrenGenresOpen: false,
        }
    }

    render() {
        return(
            <div className="filter-content">
                <p className="filter-content__title">{FILTERING_OPTIONS}</p>
                <div className="filters-content__elements">
                    <div className="filters-content__elements__filter-element">
                        <div className="custom-green-input-wrapper black-color-input">
                            <TextField
                                label="Názov klubu"
                                name="title"
                                value={this.props.filter.title}
                                onChange={this.props.handleTitleChange}
                            />
                        </div>
                    </div>
                    <div className="tree-select-wrapper custom-white-tree-select-dropdown tree-select-black tree-select-wrapper-filter-genre">
                        <p className="selectfield-label required">{GENRE_CLUB}</p>
                        <br/>
                        <TreeSelect
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            transitionName="rc-tree-select-dropdown-slide-up"
                            choiceTransitionName="rc-tree-select-selection__choice-zoom"
                            dropdownStyle={{ maxHeight: 200, overflow: 'auto', zIndex: 1500 }}
                            placeholder='Všetky'
                            showSearch={false} 
                            allowClear
                            treeLine
                            value={this.props.filter.genre}
                            treeData={filterBasicGenres(listToTreeUniqueValues(this.props.genres), this.props.filter.genre)}
                            inputIcon={<img src={'/img/icons/arrow-down-sign-to-navigate.svg'} className="treeselect-arrow-down" alt={ALT_ICON} />}
                            treeNodeFilterProp="title"
                            filterTreeNode={false}
                            treeDefaultExpandAll={true}
                            open={this.state.tsGenresOpen}
                            notFoundContent='Načítavam ...'
                            onChange={(value) => {
                                if (value === this.props.genres)
                                    this.setState({ tsGenresOpen: true });
                                else
                                    this.setState({ tsGenresOpen: false });

                                this.props.onClubGenreChange(value);
                            }}
                            onDropdownVisibleChange={(v) => {
                                this.setState({
                                    tsGenresOpen: v,
                                });

                                return true;
                            }}
                        />
                        {
                            hasChildrenGenres(listToTreeUniqueValues(this.props.genres), this.props.filter.genre) ? (
                                <div className="tree-select-wrapper custom-white-tree-select-dropdown tree-select-black no-margin-left">
                                    <br/>
                                    <TreeSelect
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        transitionName="rc-tree-select-dropdown-slide-up"
                                        choiceTransitionName="rc-tree-select-selection__choice-zoom"
                                        dropdownStyle={{ maxHeight: 200, overflow: 'auto', zIndex: 1500 }}
                                        placeholder='Podžáner'
                                        showSearch={false} 
                                        allowClear
                                        treeLine
                                        value={this.props.filter.childrenGenre}
                                        treeData={filterChildrenGenres(listToTreeUniqueValues(this.props.genres), this.props.filter.genre)}
                                        inputIcon={<img src={'/img/icons/arrow-down-sign-to-navigate.svg'} className="treeselect-arrow-down" alt={ALT_ICON} />}
                                        treeNodeFilterProp="title"
                                        filterTreeNode={false}
                                        treeDefaultExpandAll={true}
                                        open={this.state.tsChildrenGenresOpen}
                                        notFoundContent='Načítavam ...'
                                        onChange={(value) => {
                                            if (value === this.props.genres)
                                                this.setState({ tsChildrenGenresOpen: true });
                                            else
                                                this.setState({ tsChildrenGenresOpen: false });

                                            this.props.onEventMusicChildrenGenresChange(value);
                                        }}
                                        onDropdownVisibleChange={(v) => {
                                            this.setState({
                                                tsChildrenGenresOpen: v,
                                            });

                                            return true;
                                        }}
                                    />
                                </div> 
                            ) : ''
                        }
                    </div> 
                    <div className="tree-select-wrapper custom-white-tree-select-dropdown tree-select-black tree-select-wrapper-calendar tree-select-wrapper-filter-club-type">
                        <p className="selectfield-label required">{TYPE_CLUB}</p>
                        <br/>
                        <TreeSelect
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            transitionName="rc-tree-select-dropdown-slide-up"
                            choiceTransitionName="rc-tree-select-selection__choice-zoom"
                            dropdownStyle={{ maxHeight: 200, overflow: 'auto', zIndex: 1500 }}
                            placeholder='Všetky'
                            showSearch={false} 
                            allowClear
                            treeLine
                            value={this.props.filter.type}
                            treeData={listToTreeUniqueValues(this.props.types)}
                            inputIcon={<img src={'/img/icons/arrow-down-sign-to-navigate.svg'} className="treeselect-arrow-down" alt={ALT_ICON} />}
                            treeNodeFilterProp="title"
                            filterTreeNode={false}
                            treeDefaultExpandAll={true}
                            open={this.state.tsTypesOpen}
                            notFoundContent='Načítavam ...'
                            onChange={(value) => {
                                if (value === this.props.types)
                                    this.setState({ tsTypesOpen: true });
                                else
                                    this.setState({ tsTypesOpen: false });

                                this.props.onClubTypeChange(value);
                            }}
                            onDropdownVisibleChange={(v) => {
                                this.setState({
                                    tsTypesOpen: v,
                                });

                                return true;
                            }}
                        />
                    </div> 
                    <div className="filters-content__elements__filter-element">
                        <div className="custom-green-input-wrapper black-color-input">
                            <TextField
                                label="Mesto"
                                name="city"
                                value={this.props.filter.city}
                                onChange={this.props.handleCityChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );   
    }
}

export default ProfileClubFilters;
